import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import LeaseApiService from '../../services/apiService';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const UnitDetails = ({ tableLoading, furnishing, refferedBy, furniturePlan, enteredBy, setTransectionData, transectionData, manDateList, reserveAccList, keyStatusList, paymentPlan, unitCostList, projectStatus, costAccount, agent }) => {
    const { currencyPrecision } = useCurrency();

    const handleAmountBlur = (e) => {
        const { name, value } = e.target;
        const decimals = currencyPrecision?.decimalNumbers || 2;
        const num = value === '' || value === null || isNaN(Number(value)) ? 0 : Number(value);
        setTransectionData((prev) => ({ ...prev, [name]: num.toFixed(decimals) }));
    };
    const formatDisplay = (value) => {
        if (value === '' || value === null || value === undefined || Number(value) === 0) {
            return (0).toFixed(currencyPrecision?.decimalNumbers || 2);
        }
        return value;
    };

    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            if (name === "firstName" || name === "lastName") {
                updatedData.fullName = `${updatedData.firstName || ""} ${updatedData.lastName || ""}`.trim();
            }
            return updatedData;
        });
    };
    const handleDropDownChange = async ({ name, value }) => {
        setTransectionData(prev => ({ ...prev, [name]: value }));
    };
    const handleNumericKeyPress = (e) => {
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Home', 'End'];
        if (allowedKeys.includes(e.key)) return;
        if (e.key === '.' && !e.target.value.includes('.')) return;
        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}

                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit Model</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.unitModel} onChange={handleInputChange} name="unitModel" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Service Charge</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.serviceCharge)} onChange={handleInputChange} onBlur={handleAmountBlur} name="serviceCharge" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Mandate</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.mandate}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'mandate', value: selectedOption })}
                            options={manDateList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Unit Style</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.unitStyle} onChange={handleInputChange} name="unitStyle" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Reserved Fund</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.reservedFund)} onChange={handleInputChange} onBlur={handleAmountBlur} name="reservedFund" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Reserved Fund Ac Code</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.reservedAccCode}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'reservedAccCode', value: selectedOption })}
                            options={reserveAccList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Store Room(s)</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.storeRoom} onChange={handleInputChange} name="storeRoom" />
                    </div>
                    <div className="d-flex">
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Owner Occupied</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="occupied"
                                style={{ width: '20px', height: '20px' }}
                                checked={transectionData.occupied}
                                onChange={(e) => setTransectionData(prev => ({ ...prev, occupied: e.target.checked }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Property Registered</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="propertyRegistered"
                                style={{ width: '20px', height: '20px' }}
                                checked={transectionData.propertyRegistered}
                                onChange={(e) => setTransectionData(prev => ({ ...prev, propertyRegistered: e.target.checked }))}
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Mortgaged</label>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="mortgaged"
                            style={{ width: '20px', height: '20px' }}
                            checked={transectionData.mortgaged}
                            onChange={(e) => setTransectionData(prev => ({ ...prev, mortgaged: e.target.checked }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Plot No</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.plotNO} onChange={handleInputChange} name="plotNO" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Company </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.company} onChange={handleInputChange} name="company" disabled={!transectionData?.mortgaged} />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Finance Offered Via</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.financeOffered} onChange={handleInputChange} name="financeOffered" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Plot Size</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.plotSize)} onChange={handleInputChange} onBlur={handleAmountBlur} name="plotSize" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Leased</label>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="leased"
                            style={{ width: '20px', height: '20px' }}
                            checked={transectionData.leased}
                            onChange={(e) => setTransectionData(prev => ({ ...prev, leased: e.target.checked }))}
                        />
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.rentAmount)} onChange={handleInputChange} onKeyDown={handleNumericKeyPress} onBlur={handleAmountBlur} name="rentAmount" disabled={!transectionData?.leased} />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Lease Expiry</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.expiryDate}
                            onChange={(date) => handleDateChange({ name: 'expiryDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Completion Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.completionDate}
                            onChange={(date) => handleDateChange({ name: 'completionDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Key Status</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.statusKey}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'statusKey', value: selectedOption })}
                            options={keyStatusList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Unit Cost</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.unitCost}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'unitCost', value: selectedOption })}
                            options={unitCostList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Payment Plan</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.paymentPlan}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'paymentPlan', value: selectedOption })}
                            options={paymentPlan?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Project Status</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.status}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
                            options={projectStatus?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Cost Account</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.costAccount}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'costAccount', value: selectedOption })}
                            options={costAccount?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Agent</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.agent}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'agent', value: selectedOption })}
                            options={agent?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Furnishing</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.furnishing}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'furnishing', value: selectedOption })}
                            options={furnishing?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Additional Work Cost</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.additionalWorkCost)} onChange={handleInputChange} onBlur={handleAmountBlur} name="additionalWorkCost" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Street No</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.streetNo} onChange={handleInputChange} name="streetNo" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Referred By</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.refferedBy}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'refferedBy', value: selectedOption })}
                            options={refferedBy?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Opt 2 Cost</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.opt2Cost)} onChange={handleInputChange} onBlur={handleAmountBlur} name="opt2Cost" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Created By *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.enteredBy}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'enteredBy', value: selectedOption })}
                            options={enteredBy?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Referred On</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.reffferedDate}
                            onChange={(date) => handleDateChange({ name: 'reffferedDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Opt 3 Cost</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.opt3Cost)} onChange={handleInputChange} onBlur={handleAmountBlur} name="opt3Cost" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Entered Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.enteredDate}
                            onChange={(date) => handleDateChange({ name: 'enteredDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            style={{ width: '100px' }}
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Furniture Plan</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.furniturePlan}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'furniturePlan', value: selectedOption })}
                            options={furniturePlan?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Furniture Total Cost</label>
                        <input type="text" className="p-2 form-control w-75" value={formatDisplay(transectionData?.furnitureCost)} onChange={handleInputChange} onBlur={handleAmountBlur} name="furnitureCost" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Date Modified</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.modifiedDate}
                            onChange={(date) => handleDateChange({ name: 'modifiedDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            style={{ width: '100px' }}
                            className="p-2 form-control w-100"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default UnitDetails